import React from "react";
import "./MeetTheTeam.scss"

import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardText,
  } from "reactstrap";

class MeetTheTeam extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
            TeamList : {
                "Gary" : {
                    name: "Gary Barretto",
                    degree: "Mechatronics Engineering",
                    link: "https://www.linkedin.com/in/garybarretto/",
                    image: require("assets/img/Gary.jpeg")
                },
                "Vishal" : {
                    name: "Vishal Bhatia",
                    degree: "Mechatronics Engineering",
                    link: "https://www.linkedin.com/in/vishalbhatia2/",
                    image: require("assets/img/Vishal.jpeg")
                },
                "Christie" : {
                    name: "Christie Condron",
                    degree: "Mechatronics Engineering",
                    link: "https://www.linkedin.com/in/cecondron/",
                    image: require("assets/img/Christie.jpeg")
                },
                "Pavi" : {
                    name: "Pavithran Pathmarajah",
                    degree: "Software Engineering",
                    link: "https://www.linkedin.com/in/pavip/",
                    image: require("assets/img/Pavi.jpeg")
                },
                "Pareek" : {
                    name: "Pareek Ravi",
                    degree: "Software Engineering",
                    link: "https://www.linkedin.com/in/pareekravi/",
                    image: require("assets/img/Pareek.jpeg")
                },
                "Gino" : {
                    name: "Gino Salayo",
                    degree: "Mechatronics Engineering",
                    link: "https://www.linkedin.com/in/ginosalayo/",
                    image: require("assets/img/Gino.jpeg")
                },
                "Kunal" : {
                    name: "Kunal Shah",
                    degree: "Software Engineering",
                    link: "https://www.linkedin.com/in/shah-kunal/",
                    image: require("assets/img/Kunal.jpeg")
                },
            }
        };
        
    }
    


    circleImage(name){
        const data = this.state.TeamList[name]
        return (
            <div className="homeTeamCard card-user">
                <div className="author">
                    <a href={data.link} target="_blank">
                      <img
                        className="avatar"
                        src={data.image}
                      />
                      <p className="title">{data.name}</p>
                    </a>
                    <p className="description">{data.degree}</p>
                  </div>
                
                  {/* <div className="button-container">
                    <Button className="btn-icon btn-round" color="facebook">
                      <i className="fab fa-linkedin" />
                    </Button>
                  </div> */}
            </div>
        )
    }

    


	render() {
		return (
			<div className="teamSection section" ref={this.props.refs}>
                <h1 className="center">Meet the Team</h1>
                <div className="teamIconsArray">
                    {this.circleImage("Kunal")}
                    {this.circleImage("Gino")}
                    {this.circleImage("Pareek")}
                    {this.circleImage("Pavi")}
                    {this.circleImage("Christie")}
                    {this.circleImage("Vishal")}
                    {this.circleImage("Gary")}
                </div>
			</div>
		);
	}
}
export default MeetTheTeam;
